import React, { useState } from 'react';

import { DataTableAction } from 'components/DataTable';
import { ENTITY_SOP } from 'constants/schemas';
import NewSopDialog from 'components/NewSopDialog';
import PropTypes from 'prop-types';
import { SopIcon } from 'constants/icon.constants';
import { formatType } from 'utils/entity.utils';

function ActionAddSop(props) {
  const { initState } = props;
  const [dialogOpen, setDialogOpen] = useState(false);
  const isTemplate = initState?.is_template;
  return (
    <>
      <DataTableAction
        label={`New ${formatType(ENTITY_SOP, { template: isTemplate })}`}
        icon={<SopIcon colored template={isTemplate} />}
        onClick={() => setDialogOpen(true)}
      />
      <NewSopDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        initState={initState}
      />
    </>
  );
}

ActionAddSop.propTypes = {
  initState: PropTypes.object,
};

export default ActionAddSop;
